export class Statuschart {
    personId:string;
    name:string;
    almost:number;
    overdue:number;
    ontime:number;
}